import { type ReactNode, createContext, useContext } from 'react';

/**
 * Share-scoped flags for public share pages (originalFile inclusion, collaboration, etc).
 * Provided once by the share page and consumed by the Inspector so these flags don't have
 * to be threaded as individual props through DamLayout. `null` means not in a share context.
 */
export type ShareConfig = {
  id?: string;
  includeOriginalFile?: boolean;
  collaborationEnabled?: boolean;
  requesterIsMemberOfShare?: boolean;
};

const ShareConfigContext = createContext<ShareConfig | null>(null);

export const ShareConfigProvider = ({ value, children }: { value: ShareConfig | null; children: ReactNode }) => (
  <ShareConfigContext.Provider value={value}>{children}</ShareConfigContext.Provider>
);

export const useShareConfig = () => useContext(ShareConfigContext);
